import { Link } from 'react-router-dom';
import BookmarkIcon from '../activity-details/icons/BookmarkIcon';
import { ACTIVITY_DETAILS_COLORS } from '../activity-details';

/**
 * Empty state shown when user has no bookmarked activities
 * Provides call-to-action to explore activities
 */
export default function EmptyLibraryState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      {/* Icon */}
      <div className="mb-6 p-6 bg-gray-100 rounded-full">
        <BookmarkIcon size={48} color="#9CA3AF" />
      </div>

      {/* Heading */}
      <h2
        className="text-2xl font-bold mb-3"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#2D3648',
          letterSpacing: '-0.48px',
        }}
      >
        Nothing saved yet
      </h2>

      {/* Description */}
      <p
        className="text-base mb-8 max-w-md"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#4D5762',
          lineHeight: '1.5',
        }}
      >
        Tap the bookmark on any spark to keep it for another day.
      </p>

      {/* Call to Action */}
      <Link
        to="/home"
        className={`px-8 py-3 bg-[${ACTIVITY_DETAILS_COLORS.background}] text-white rounded-xl font-medium hover:bg-[#FF5722] transition-colors`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '16px',
        }}
      >
        Find a spark
      </Link>
    </div>
  );
}
